module.exports = __webpack_public_path__ + "static/media/3 02 Tulleord Sgo.6b0278b2.mp3";